import {ready} from './utils';
import loadAccordion from './accordion';
import loadCheckboxRadio from './checkbox-radio';
import loadDropdowns from './dropdown';
import loadGlobalVue from './global-vue';
import loadHoldState from './hold-state';
import loadSocialShare from './social-share';
import loadNavbar from './navbar';
import loadSpecSearch from './spec-search';
import loadResponsiveTables from './table-responsive';
import loadTabs from './tabs';
import loadTooltip from './tooltip';
import loadResponsiveImagesPolyfill from './responsive-images';
import loadInfoScroller from './info-scroller';
import loadToggler from './toggler';
import loadCarouselQuotes from './carousel-quotes';
import loadCarouselImages from './carousel-images';
import loadFullWidthCarousel from '../full-carousel';
import loadSlideshow from './slideshow';
import rotateImages from './rotate-images';

ready(() => {
  loadGlobalVue();
  loadAccordion();
  loadCheckboxRadio();
  loadDropdowns();
  loadHoldState();
  loadSocialShare();
  loadNavbar();
  loadSpecSearch();
  loadResponsiveTables();
  loadTabs();
  loadTooltip();
  loadInfoScroller();
  loadToggler();
  loadCarouselQuotes();
  loadCarouselImages();
  loadFullWidthCarousel();
  loadSlideshow();
  rotateImages();
  setTimeout(loadResponsiveImagesPolyfill, 0);
});

if (document.documentMode) {
  document.documentElement.classList.add('msie');
}
